// import React, { useState } from 'react';
// import {
//   Container,
//   Row,
//   Col,
//   Card,
//   Button,
//   Form,
//   Pagination,
//   Badge,
// } from 'react-bootstrap';
// import './UserManagementDashboard.css';
// import UserProfileDropdown from '../../components/UserProfile/UserProfile';
// import SeedsLogo from '../../assets/images/SeedsLogo.png';
// import { BiTransferAlt } from 'react-icons/bi';
// import { FiPlus } from 'react-icons/fi';
// import HomeSvg from '../../components/SVG/HomeSvg';
// import { GrLocation } from 'react-icons/gr';
// import { useNavigate } from 'react-router-dom';
// import TransferModal from './TransferModal/TransferModal';
// import AddUserModal from './AddUserModal/AddUserModal';

// const UserManagementDashboard = () => {
//   const navigate = useNavigate();

//   const [showTransferModal, setShowTransferModal] = useState(false);
//   const openTransferModal = () => setShowTransferModal(true);
//   const closeTransferModal = () => setShowTransferModal(false);

//   const [showAddUserModal, setShowAddUserModal] = useState(false);
//   const openAddUserModal = () => setShowAddUserModal(true);
//   const closeAddUserModal = () => setShowAddUserModal(false);

//   return (
//     <Container fluid className="user-management">
//       {/* Logo */}
//       <div className="userContentHeader">
//         <div className="userLogo">
//           <img src={SeedsLogo} alt="logo" className="SeedsLogo" />
//         </div>
//         <div className="headerRightPanel">
//           <UserProfileDropdown />
//         </div>
//       </div>

//       {/* Header */}
//       <Row className="user-management-header align-items-center">
//         <Col className="headerLeft">
//           <div onClick={() => navigate('/user-management')}>
//             <HomeSvg fillColor={'#002355'} />
//           </div>
//           <h5 className="title">Seeds User Management</h5>
//         </Col>
//         <Col className="text-end">
//           <Button
//             variant="outline-secondary"
//             className="me-2"
//             style={{ color: 'black' }}
//             onClick={openTransferModal}
//           >
//             <BiTransferAlt />
//             Transfer
//           </Button>
//           <Button
//             variant="primary"
//             style={{ backgroundColor: '#002355', border: 'none' }}
//             onClick={openAddUserModal}
//           >
//             <FiPlus />
//             Add User
//           </Button>
//         </Col>

//         {showTransferModal && <TransferModal closeModal={closeTransferModal} />}
//         {showAddUserModal && <AddUserModal closeModal={closeAddUserModal} />}
//       </Row>

//       <div className="dashboard-content">
//         <div>
//           <p className="subtitle">Manage branches and personnel across India</p>
//         </div>
//         {/* Stats Cards */}
//         <Row className="stats-row">
//           <Col md={3}>
//             <Card className="stat-card">
//               <h6>Total Branches</h6>
//               <h1>5</h1>
//               <p>Across India</p>
//             </Card>
//           </Col>
//           <Col md={3}>
//             <Card className="stat-card">
//               <h6>RO</h6>
//               <h1>6</h1>
//               <p>Active personnel</p>
//             </Card>
//           </Col>
//           <Col md={3}>
//             <Card className="stat-card">
//               <h6>BM</h6>
//               <h1>3</h1>
//               <p>One per branch</p>
//             </Card>
//           </Col>
//           <Col md={3}>
//             <Card className="stat-card">
//               <h6>BCM</h6>
//               <h1>2</h1>
//               <p>One per branch</p>
//             </Card>
//           </Col>
//         </Row>

//         {/* Search */}
//         <Row className="my-4">
//           <Col>
//             <Form.Control
//               type="text"
//               placeholder="Search by branch number or name..."
//             />
//           </Col>
//         </Row>

//         {/* Branch List */}
//         {[1, 2].map((_, i) => (
//           <Card className="branch-card mb-3" key={i}>
//             {/* <Card.Body> */}
//             <Col>
//               <Row className="card-header-row">
//                 <Col style={{ textAlign: 'left' }}>
//                   <h5>Mumbai Central</h5>
//                   <p className="location">
//                     <GrLocation style={{ marginRight: '8px' }} />
//                     Mumbai, Maharashtra
//                   </p>
//                 </Col>

//                 <Col md={4} className="card-btn text-end">
//                   <button
//                     className="mb-2 action-btn"
//                     onClick={() => navigate('/user-management/branch-officers')}
//                   >
//                     View More
//                   </button>
//                   <button className="mb-2 action-btn">
//                     <FiPlus />
//                     Add RO
//                   </button>
//                 </Col>
//               </Row>
//               <Col className="card-content-row">
//                 <div className="user-tags">
//                   <div className="user-tag-group">
//                     <div className="user-tag">
//                       <Badge bg="success" className="officer-badge success">
//                         BM
//                       </Badge>
//                       <div className="success-container">
//                         <h6>Sushmit</h6>
//                         <p>sushmit@gmail.com</p>
//                       </div>
//                     </div>
//                   </div>
//                   <div className="user-tag-group">
//                     <div className="user-tag">
//                       <Badge bg="secondary" className="officer-badge secondary">
//                         BCM
//                       </Badge>
//                       <div className="secondary-container">
//                         <h6>Sushmit</h6>
//                         <p>sushmit@gmail.com</p>
//                       </div>
//                     </div>
//                   </div>
//                   <div className="user-tag-group">
//                     <div className="user-tag">
//                       <Badge bg="info" className="officer-badge info">
//                         RO
//                       </Badge>
//                       <div className="info-container">
//                         <h6>Sushmit</h6>
//                         <p>sushmit@gmail.com</p>
//                       </div>
//                     </div>
//                     <div className="user-tag">
//                       <Badge bg="info" className="officer-badge info">
//                         RO
//                       </Badge>
//                       <div className="info-container">
//                         <h6>Sushmit</h6>
//                         <p>sushmit@gmail.com</p>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </Col>
//             </Col>
//             {/* </Card.Body> */}
//           </Card>
//         ))}

//         {/* Pagination */}
//         <div className="pagination-wrapper text-center mt-4">
//           <Pagination>
//             <Pagination.First />
//             <Pagination.Prev />
//             {[1, 2, 3, 4, 5].map((n) => (
//               <Pagination.Item key={n} active={n === 1}>
//                 {n}
//               </Pagination.Item>
//             ))}
//             <Pagination.Next />
//             <Pagination.Last />
//           </Pagination>
//         </div>
//       </div>
//     </Container>
//   );
// };

// export default UserManagementDashboard;

import React, { useEffect, useState } from 'react';
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Form,
  Badge,
  Pagination,
  Dropdown,
} from 'react-bootstrap';
import axios from 'axios';
import './UserManagementDashboard.css';
import UserProfileDropdown from '../../components/UserProfile/UserProfile';
import ChangePasswordModal from './ChangePassword/ChangePasswordModal';
import ChangePasswordAdminModal from './ChangePasswordAdmin/ChangePasswordAdminModal';
import SeedsLogo from '../../assets/images/SeedsLogo.png';
import { BiTransferAlt, BiUser } from 'react-icons/bi';
import { FiPlus, FiUpload } from 'react-icons/fi';
import { FaExternalLinkAlt, FaSearch } from 'react-icons/fa';
import HomeSvg from '../../components/SVG/HomeSvg';
import { GrLocation } from 'react-icons/gr';
import { useNavigate } from 'react-router-dom';
import TransferModal from './TransferModal/TransferModal';
import AddUserModal from './AddUserModal/AddUserModal';
import BranchMap from '../../components/BranchMap/BranchMap';
import { FaMapMarkedAlt } from "react-icons/fa";
import MapModal from '../../components/MapModal/MapModal';
import UpgradeModal from './UpgradeModal/UpgradeModal';
import { toast } from 'react-toastify';
import { BsThreeDotsVertical } from 'react-icons/bs';
import Sidebar from '../../components/Sidebar/Sidebar.jsx'
import BulkUploadModal from './BulkUploadModal/BulkUploadModal';


const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const UserManagementDashboard = () => {
  const navigate = useNavigate();

  // Modals + UI state
  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
  const [showChangePasswordAdminModal, setShowChangePasswordAdminModal] = useState(false);
  const [showTransferModal, setShowTransferModal] = useState(false);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const [showAddUserModal, setShowAddUserModal] = useState(false);
  const [showBulkUploadModal, setShowBulkUploadModal] = useState(false);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [preSelectedRole, setPreSelectedRole] = useState('');

  // Data state
  const [branchData, setBranchData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');

  // Pagination state for dashboard listing
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const itemsPerPage = 5;

  const [showMap, setShowMap] = useState(false);
  const [mapCoords, setMapCoords] = useState({ lat: null, lng: null, name: "" });

  const [allBranches, setAllBranches] = useState([]);

  const openMapPopup = (branch) => {
    setMapCoords({
      lat: branch.latitude,
      lng: branch.longitude,
      name: branch.branch_name,
    });
    setShowMap(true);
  };

  const closeMapPopup = () => setShowMap(false);

  // Open/close helpers for modals
  const openChangePasswordModal = () => setShowChangePasswordModal(true);
  const closeChangePasswordModal = () => setShowChangePasswordModal(false);

  const openChangePasswordAdminModal = () => setShowChangePasswordAdminModal(true);
  const closeChangePasswordAdminModal = () => setShowChangePasswordAdminModal(false);

  const openTransferModal = () => setShowTransferModal(true);
  const closeTransferModal = () => setShowTransferModal(false);

  const openUpgradeModal = () => setShowUpgradeModal(true);
  const closeUpgradeModal = () => setShowUpgradeModal(false);

  const openBulkUploadModal = () => setShowBulkUploadModal(true);
  const closeBulkUploadModal = () => setShowBulkUploadModal(false);

  const openAddUserModal = (branch = null, role = '') => {
    setSelectedBranch(branch);
    setPreSelectedRole(role);
    setShowAddUserModal(true);
  };

  const closeAddUserModal = () => {
    setShowAddUserModal(false);
    setSelectedBranch(null);
    setPreSelectedRole('');

    fetchBranchData(currentPage);
  };

  // format state text
  const formatStateName = (state) => {
    if (!state) return '';
    try {
      return String(state).replace(/_/g, ' ').toUpperCase();
    } catch {
      return state;
    }
  };

  // robust token extractor (matches your modal logic)
  const getToken = () => {
    try {
      const raw =
        sessionStorage.getItem('tokens') || sessionStorage.getItem('token') || '';
      if (!raw) return '';
      try {
        const parsed = JSON.parse(raw);
        if (parsed && typeof parsed === 'object') {
          const t =
            parsed.token ||
            parsed.accessToken ||
            parsed.access_token ||
            parsed.refreshToken ||
            '';
          if (typeof t === 'string' && t.trim())
            return t.trim().replace(/^Bearer\s+/i, '');
        }
      } catch { }
      return String(raw)
        .trim()
        .replace(/^Bearer\s+/i, '');
    } catch (e) {
      console.error('getToken error', e);
      return '';
    }
  };

  const fetchAllBranches = async () => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${API_BASE_URL}/officer/get-branch-officer-report`,
        {
          params: {
            page: 1,
            limit: 2000,   // Fetch ALL branches (adjust as needed)
          },
          headers: {
            Authorization: token ? `Bearer ${token}` : "",
            accept: "*/*",
          },
        }
      );

      if (response.data?.status) {
        setAllBranches(response.data.data.officers || []);
      } else {
        setAllBranches([]);
      }
    } catch (err) {
      console.error("Error fetching all branches:", err);
      setAllBranches([]);
    }
  };

  // fetch branch report
  const fetchBranchData = async (page = 1) => {
    setLoading(true);
    setError(null);
    try {
      const token = getToken();
      const response = await axios.get(
        `${API_BASE_URL}/officer/get-branch-officer-report`,
        {
          params: {
            page,
            limit: itemsPerPage,
            is_download: false,
            ...(debouncedSearch && { global_search: debouncedSearch })
          },
          headers: {
            Authorization: token ? `Bearer ${token}` : '',
            accept: '*/*',
          },
        }
      );

      if (response.data && response.data.status) {
        setBranchData(response.data.data);
        const totalCount =
          Number(response.data.data.branch_report?.total_branch_count) || 0;
        const pages = Math.max(1, Math.ceil(totalCount / itemsPerPage));
        // setTotalPages(pages);
        // setCurrentPage(page);
        setTotalPages(response.data.data?.pagination?.total_pages);
        setCurrentPage(response.data.data?.pagination?.current_page);
      } else {
        setBranchData({
          officers: [],
          branch_report: { total_branch_count: 0 },
        });
        setTotalPages(1);
      }
    } catch (err) {
      console.error('Error fetching branch data:', err);
      setError('Failed to load branch data. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 400); // wait for user to stop typing

    return () => clearTimeout(handler);
  }, [searchQuery]);

  useEffect(() => {
    fetchBranchData(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedSearch]);

  useEffect(() => {
    fetchAllBranches();
  }, []);

  // pagination handler
  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      fetchBranchData(pageNumber);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  // view more navigate
  const handleViewMore = (branchCode, branchName) => {
    navigate(
      `/user-management/branch-officers?branch=${branchCode}&name=${encodeURIComponent(
        branchName || 'N/A'
      )}`
    );
  };

  const handleAddRO = (branch) => openAddUserModal(branch, 'RO');

  // Filtering for branch cards (search on name or code)
  const getFilteredBranches = () => {
    if (!branchData?.officers) return [];
    if (!searchQuery.trim()) return branchData.officers;

    const q = searchQuery.toLowerCase();
    return branchData.officers.filter(
      (branch) =>
        (branch.branch_code || '').toLowerCase().includes(q) ||
        (branch.branch_name || '').toLowerCase().includes(q)
    );
  };

  // helpers to get active officer by role
  const getOfficerByRole = (branch, roleCode) => {
    if (!branch?.officer_details) return null;
    // const officer = branch.officer_details.find(
    //   (o) => o.role_code === roleCode
    // );
    // if (!officer) return null;
    const officers = branch.officer_details.filter(
      (o) => o.role_code === roleCode && o.is_active === true
    );
    if (!officers) return null;
    // const isActive =
    //   officer.is_active === true ||
    //   officer.is_active === '1' ||
    //   officer.is_active === 1;
    // if (!isActive) return null;
    return officers?.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))?.[0];
  };

  // return all active ROs for a branch
  const getROs = (branch) => {
    if (!branch?.officer_details) return [];
    const ros =
      branch.officer_details.filter((officer) => {
        if (officer.role_code !== 'RO') return false;
        const isActive =
          officer.is_active === true ||
          officer.is_active === '1' ||
          officer.is_active === 1;
        return isActive;
      }) || [];
    return ros.slice(0, 2);
  };

  const openDetails = (type) => {
    navigate(`/user-management/details/${type}`);
  };

  if (loading) {
    return (
      <Container fluid className="user-management" style={{ padding: "0px" }}>
        <div className="applicationsDashboard">
          {/* LEFT SIDEBAR */}
          <Sidebar />

          <div className="dashboardMainContent">
            {/* HEADER */}
            <div className="contentHeader">
              <div className="userLogo">
                <img src={SeedsLogo} alt="logo" className="SeedsLogo" />
              </div>
              <div className="headerRightPanel">
                <UserProfileDropdown />
              </div>
            </div>

            <div className="userPageContent">
              <div className="text-center my-5">
                <p>Loading branch data...</p>
              </div>
            </div>
          </div>
        </div>
      </Container>
    );
  }

  if (error) {
    return (
      <Container fluid className="user-management" style={{ padding: "0px" }}>
        <div className="applicationsDashboard">
          {/* LEFT SIDEBAR */}
          <Sidebar />

          <div className="dashboardMainContent">
            {/* HEADER */}
            <div className="contentHeader">
              <div className="userLogo">
                <img src={SeedsLogo} alt="logo" className="SeedsLogo" />
              </div>
              <div className="headerRightPanel">
                <UserProfileDropdown />
              </div>
            </div>

            <div className="userPageContent">
              <div className="text-center my-5">
                <p className="text-danger">{error}</p>
              </div>
            </div>
          </div>
        </div>
      </Container>
    );
  }

  const filteredBranches = getFilteredBranches();

  return (
    <Container fluid className="user-management" style={{ padding: "0px" }}>
      <div className="applicationsDashboard">
        {/* LEFT SIDEBAR */}
        <Sidebar />

        <div className="dashboardMainContent">

          {/* HEADER */}
          <div className="contentHeader">
            <div className="userLogo">
              <img src={SeedsLogo} alt="logo" className="SeedsLogo" />
            </div>
            <div className="headerRightPanel">
              <UserProfileDropdown />
            </div>
          </div>

          <div className="userPageContent">

            <div className="user-management-header d-flex justify-content-between align-items-center mb-4">
              <div className="headerLeft d-flex align-items-center gap-2">
                <div
                  onClick={() => navigate('/user-management')}
                  style={{ cursor: 'pointer' }}
                >
                  <HomeSvg fillColor={'#002355'} />
                </div>
                <h5 className="title mb-0">Seeds User Management</h5>
              </div>

              {/* OPTIONS DROPDOWN */}
              <div className="text-end">
                <Dropdown align="end">
                  <Dropdown.Toggle
                    id="user-management-options"
                  >
                    <BsThreeDotsVertical size={20} />
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item onClick={openChangePasswordModal}>
                      Change Password
                    </Dropdown.Item>

                    <Dropdown.Item onClick={openChangePasswordAdminModal}>
                      Change Password - Admin
                    </Dropdown.Item>

                    <Dropdown.Item onClick={openTransferModal}>
                      <BiTransferAlt className="me-2" />
                      Transfer
                    </Dropdown.Item>

                    <Dropdown.Item onClick={openUpgradeModal}>
                      <BiTransferAlt className="me-2" />
                      Upgrade
                    </Dropdown.Item>

                    {/* <Dropdown.Item onClick={openAddUserModal}> */}
                    <Dropdown.Item onClick={() => openAddUserModal('HO', '')}>
                      <FiPlus className="me-2" />
                      Add User
                    </Dropdown.Item>

                    <Dropdown.Item onClick={openBulkUploadModal}>
                      <FiUpload className="me-2" />
                      Bulk Upload User
                    </Dropdown.Item>

                    {/* <Dropdown.Divider /> */}

                    <Dropdown.Item
                      onClick={() => navigate('/user-management/roles-permissions/dashboard?tab=users-permissions')}
                    >
                      <BiUser className="me-2" />
                      Roles & Permissions
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>

            {/* Modals */}
            {showChangePasswordModal && (
              <ChangePasswordModal
                closeModal={closeChangePasswordModal}
                onSave={async (result) => {
                  try {
                    await fetchBranchData(currentPage);
                  } catch (e) {
                    console.warn(
                      'Failed to refresh branch data after password change',
                      e
                    );
                  }
                  return result;
                }}
              />
            )}

            {showChangePasswordAdminModal && (
              <ChangePasswordAdminModal closeModal={closeChangePasswordAdminModal} />
            )}

            {showTransferModal && (
              <TransferModal
                closeModal={closeTransferModal}
                branchList={branchData?.officers}
                onSwapSuccess={() => fetchBranchData(currentPage)}
                allBranches={allBranches}
              />
            )}

            {showUpgradeModal && (
              <UpgradeModal
                closeModal={closeUpgradeModal}
                branchList={branchData?.officers}
                onSwapSuccess={() => fetchBranchData(currentPage)}
                allBranches={allBranches}
              />
            )}

            {showAddUserModal && (
              <AddUserModal
                closeModal={closeAddUserModal}
                selectedBranch={selectedBranch}
                preSelectedRole={preSelectedRole}
              />
            )}

            {showBulkUploadModal && (
              <BulkUploadModal
                closeModal={closeBulkUploadModal}
                onCompleted={() => fetchBranchData(currentPage)}
              />
            )}

            {/* CONTENT */}
            <div className="dashboard-content">
              <div>
                <p className="subtitle">Manage branches and personnel across India</p>
              </div>

              {/* STAT CARDS */}
              <Row className="stats-row">
                <Col md={6} lg={3} className="mb-3">
                  <Card
                    className="stat-card stat-card-total"
                    onClick={() => openDetails('branches')}
                    role="button"
                    tabIndex={0}
                  >
                    <Card.Body>
                      <div className="stat-card-header">
                        <h6 className="stat-label">Total Branches</h6>
                        <FaExternalLinkAlt className="stat-link-icon" />
                      </div>
                      <h1 className="stat-value">
                        {branchData?.branch_report?.total_branch_count || 0}
                      </h1>
                      <p className="stat-description">Across India</p>
                    </Card.Body>
                  </Card>
                </Col>

                <Col md={6} lg={3} className="mb-3">
                  <Card
                    className="stat-card stat-card-ro"
                    onClick={() => openDetails('ro')}
                    role="button"
                    tabIndex={0}
                  >
                    <Card.Body>
                      <div className="stat-card-header">
                        <h6 className="stat-label">RO</h6>
                        <FaExternalLinkAlt className="stat-link-icon" />
                      </div>
                      <h1 className="stat-value">
                        {branchData?.branch_report?.ro_count || 0}
                      </h1>
                      <p className="stat-description">Active personnel</p>
                    </Card.Body>
                  </Card>
                </Col>

                <Col md={6} lg={3} className="mb-3">
                  <Card
                    className="stat-card stat-card-bm"
                    onClick={() => openDetails('bm')}
                    role="button"
                    tabIndex={0}
                  >
                    <Card.Body>
                      <div className="stat-card-header">
                        <h6 className="stat-label">BM</h6>
                        <FaExternalLinkAlt className="stat-link-icon" />
                      </div>
                      <h1 className="stat-value">
                        {branchData?.branch_report?.bm_count || 0}
                      </h1>
                      <p className="stat-description">One per branch</p>
                    </Card.Body>
                  </Card>
                </Col>

                <Col md={6} lg={3} className="mb-3">
                  <Card
                    className="stat-card stat-card-bcm"
                    onClick={() => openDetails('bcm')}
                    role="button"
                    tabIndex={0}
                  >
                    <Card.Body>
                      <div className="stat-card-header">
                        <h6 className="stat-label">BCM</h6>
                        <FaExternalLinkAlt className="stat-link-icon" />
                      </div>
                      <h1 className="stat-value">
                        {branchData?.branch_report?.bcm_count || 0}
                      </h1>
                      <p className="stat-description">One per branch</p>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>

              {/* SEARCH */}
              <div className="userSearchContainer">
                <div className="userSearchInputWrapper">
                  <FaSearch className="userSearchIcon" />
                  <input
                    type="text"
                    placeholder="Search by branch number or name..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    autoFocus
                  />
                </div>
              </div>

              {/* BRANCH CARDS */}
              {
                // filteredBranches.length > 0 ? (
                branchData?.officers?.length > 0 ? (
                  // filteredBranches.map((branch) => {
                  branchData?.officers?.map((branch) => {
                    const bmOfficer = getOfficerByRole(branch, 'BM');
                    const bcmOfficer = getOfficerByRole(branch, 'BCM');
                    const roOfficers = getROs(branch);

                    console.log({ branch });

                    return (
                      <Card className="branch-card mb-3" key={branch.branch_code}>
                        <Col>
                          <Row className="card-header-row">
                            <Col style={{ textAlign: 'left', minWidth: 0 }}>
                              <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
                                <h5>{branch.branch_name || 'N/A'}</h5>
                                <FaMapMarkedAlt
                                  size={24}
                                  style={{ cursor: "pointer", marginRight: "12px", color: "#002355" }}
                                  onClick={() => {
                                    if (branch.longitude && branch.latitude) {
                                      openMapPopup(branch)
                                    }
                                    else {
                                      toast.error("Location not Added Yet");
                                    }
                                  }}
                                />
                              </div>
                              <p className="location">
                                <GrLocation style={{ marginRight: '8px' }} />
                                {formatStateName(branch.state_name)}
                              </p>

                              {/* ⭐ Small Map Preview for This Branch */}
                              {/* <BranchMap
                        // lat={branch.latitude}
                        // lng={branch.longitude}
                        // name={branch.branch_name}
                        lat={28.6139}
                        lng={77.2090}
                        name={branch.branch_name}
                      /> */}
                            </Col>
                            <Col md={4} className="card-btn text-end">
                              <button
                                className="mb-2 action-btn"
                                onClick={() =>
                                  handleViewMore(branch.branch_code, branch.branch_name)
                                }
                              >
                                View More
                              </button>
                              <button
                                className="mb-2 action-btn"
                                onClick={() => handleAddRO(branch)}
                              >
                                <FiPlus /> Add RO
                              </button>
                            </Col>
                          </Row>

                          <Col className="card-content-row">
                            <div className="user-tags">
                              <div className="user-tag-group">
                                <div className="user-tag">
                                  <Badge bg="success" className="officer-badge success">
                                    BM
                                  </Badge>
                                  {bmOfficer ? (
                                    <div className="success-container">
                                      <h6>
                                        {bmOfficer.first_name}{' '}
                                        {bmOfficer.last_name || ''}
                                      </h6>
                                      <p>{bmOfficer.email}</p>
                                    </div>
                                  ) : (
                                    <div className="success-container empty-officer">
                                      <h6>-</h6>
                                      <p className="text-muted">No BM assigned</p>
                                    </div>
                                  )}
                                </div>
                              </div>

                              <div className="user-tag-group">
                                <div className="user-tag">
                                  <Badge
                                    bg="secondary"
                                    className="officer-badge secondary"
                                  >
                                    BCM
                                  </Badge>
                                  {bcmOfficer ? (
                                    <div className="secondary-container">
                                      <h6>
                                        {bcmOfficer.first_name}{' '}
                                        {bcmOfficer.last_name || ''}
                                      </h6>
                                      <p>{bcmOfficer.email}</p>
                                    </div>
                                  ) : (
                                    <div className="secondary-container empty-officer">
                                      <h6>-</h6>
                                      <p className="text-muted">No BCM assigned</p>
                                    </div>
                                  )}
                                </div>
                              </div>

                              <div className="user-tag-group">
                                {[].concat(roOfficers).map((r, index) => (
                                  <div
                                    className="user-tag"
                                    key={r?.officer_id || index}
                                  >
                                    <Badge bg="info" className="officer-badge info">
                                      RO
                                    </Badge>
                                    {r ? (
                                      <div className="info-container">
                                        <h6>
                                          {r.first_name} {r.last_name || ''}
                                        </h6>
                                        <p>{r.email}</p>
                                      </div>
                                    ) : (
                                      <div className="info-container empty-officer">
                                        <h6>-</h6>
                                        <p className="text-muted">No RO assigned</p>
                                      </div>
                                    )}
                                  </div>
                                ))}
                              </div>
                            </div>
                          </Col>
                        </Col>
                      </Card>
                    );
                  })
                ) : (
                  <div className="text-center my-4">
                    <p>No branches found</p>
                  </div>
                )}

              {/* Pagination */}
              <div className="pagination-wrapper text-center mt-4">
                <Pagination>
                  <Pagination.First
                    onClick={() => handlePageChange(1)}
                    disabled={currentPage === 1}
                  />
                  <Pagination.Prev
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                  />
                  {[...Array(totalPages)].map((_, index) => {
                    const pageNumber = index + 1;
                    return (
                      <Pagination.Item
                        key={pageNumber}
                        active={pageNumber === currentPage}
                        onClick={() => handlePageChange(pageNumber)}
                      >
                        {pageNumber}
                      </Pagination.Item>
                    );
                  })}
                  <Pagination.Next
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  />
                  <Pagination.Last
                    onClick={() => handlePageChange(totalPages)}
                    disabled={currentPage === totalPages}
                  />
                </Pagination>
              </div>
            </div>

            <MapModal
              show={showMap}
              onClose={closeMapPopup}
              lat={mapCoords.lat}
              lng={mapCoords.lng}
              name={mapCoords.name}
            />

          </div>{/* end userPageContent */}
        </div>{/* end dashboardMainContent */}
      </div>{/* end applicationsDashboard */}

    </Container>
  );
};

export default UserManagementDashboard;
